import { useForm } from 'react-hook-form';
import {
  channelBuyQuery,
  mobileBrandQuery,
} from '../../../../services/react-query/optionMasterQuery';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { useEffect, useState } from 'react';
import { useGetRegInfoView } from './useGetRegInfoView';

export const useGetRegViewList = () => {
  const { control, getValues, setValue, reset } = useForm();
  const [state, setState] = useState();
  const { data: mobileBrandList } = mobileBrandQuery();
  const { data: channelBuyList } = channelBuyQuery();
  const queryParams = new URLSearchParams(window.location.search);
  const warrantyCode = queryParams.get('code');

  const { loading: LoadingWarrantyView } = useGetRegInfoView({
    warrantyCode: state?.warrantyCode,
    reset,
    setValue,
    getValues,
  });

  const goBack = () => {
    navigateTo({
      pathname: ROUTES_PATH.ROUTE_REGISTRATION_LIST.PATH,
      state: getValues(),
    });
  };

  useEffect(() => {
    setState({ warrantyCode });
  }, [warrantyCode]);

  return {
    control,
    getValues,
    setValue,
    mobileBrandList,
    channelBuyList,
    LoadingWarrantyView,
    goBack,
    reset,
  };
};
